// extracted by css-extract-rspack-plugin
export default {"container":"container--Jf_xa3gJtzUoyAlu"};